module.exports = __webpack_public_path__ + "img/staffImage.29e3f3bd.jpg";